export { appOntology } from "./app";
export { dbpediaOntology } from "./dbo";
export { foafOntology } from "./foaf";
export { ldpOntology } from "./ldp";
export { llOntology } from "./ll";
export { mashOntology } from "./mash";
export { minesweeperOntology } from "./minesweeper";
export { todoOntology } from "./todo";
export { vcardOntology } from "./vcard";
